import { api } from '@api'
import type { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'

export interface Memory {
  id: string
  mediaUrl: string
  mediaMimeType: string
  description: string | null
  mediaType: string
  sharedWithAccountIds: string[]
  albumId: string | null
  createdByAccountId: string
  createdAt: string
  updatedAt: string
}

const fetchMyMemories = async (
  params?: FetchParams,
): Promise<PaginatedResponse<Memory>> => {
  const queryParams = new URLSearchParams()
  if (params?.pageParam) {
    queryParams.append('page', String(params.pageParam))
  }

  const url = `/memories/me${queryParams.toString() ? `?${queryParams.toString()}` : ''}`
  const { data } = await api.get<PaginatedResponse<Memory>>(url)
  return data
}

export const usePaginateMyMemories = () => {
  return usePaginate<Memory>('myMemories', fetchMyMemories)
}

// Keep backward-compatible export
export const usePaginateMemories = usePaginateMyMemories
